"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _getComponentDataAttributes = require("b2b-components/utils//getComponentDataAttributes");
require("./Toast.scss");
const Toast = _ref => {
  let {
    type,
    header,
    content,
    isLoading = false,
    dataAttributes
  } = _ref;
  const casedType = type.charAt(0).toUpperCase() + type.slice(1);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: `cds-Toast cds-Toast--${casedType}`
  }, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes)), isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Toast-Loader"
  }) : /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: `IconAlert${casedType}`,
    className: "cds-Toast-Icon"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.close,
    className: "cds-Toast-Close"
  }), header ? /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Toast-Header"
  }, header) : null, content);
};
exports.Toast = Toast;
//# sourceMappingURL=Toast.js.map